import { createSelector } from 'reselect'
import { userCredentialsSelector } from 'redux/selectors/user'
import activityTypes from 'helpers/enums/activityTypes'
import { getActivityPayload } from 'redux/reducers/helpers/interactiveVideo/activities'

const interactiveVideoData = state => state.interactiveVideo

export default createSelector(
	[ interactiveVideoData, userCredentialsSelector],
	( interactiveVideo, userCredentials ) => ({
		jwt: userCredentials.interactiveVideo,
		mediaSessionUid: interactiveVideo.uid,
		participantUid: interactiveVideo.participantUid,
		activityUids: getMcqActivitiesUids(interactiveVideo.activities),
	})
)

function getMcqActivitiesUids(activities) {
	return activities.reduce(
		(questionUids, activity) => {
			if (activity.type === activityTypes.MULTIPLE_CHOICE_QUESTION) {
				questionUids.push(getActivityPayload(activity).uid)
			}
			return questionUids
		}, []
	)
}
